import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const DELIVERY_STATES = [
  'init',
  'delivering',
  'reached',
  'checked',
  'inbounded',
  'failed',
  'delivered',
]

const entityColumns = {
  id: {
    model_name: 'Delivery',
    column_type: 'id',
    label_key_path: 'delivery.id',
  },
  created_at: {
    model_name: 'Delivery',
    column_type: 'datetime',
    label_key_path: 'delivery.createdAt',
  },
  updated_at: {
    model_name: 'Delivery',
    column_type: 'datetime',
    label_key_path: 'delivery.updatedAt',
  },
  order: {
    model_name: 'Delivery',
    column_type: 'belongs_to',
    label_key_path: 'delivery.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_id: {
    model_name: 'Delivery',
    column_type: 'belongs_to',
    label_key_path: 'delivery.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  delivery_at: {
    model_name: 'Delivery',
    column_type: 'datetime',
    label_key_path: 'delivery.deliveryAt',
  },
  state: {
    model_name: 'Delivery',
    column_type: 'enum',
    extra: {
      options: ['init', 'delivering', 'reached', 'checked', 'inbounded', 'failed', 'delivered'],
    },
    label_key_path: 'delivery.state',
  },
  reach_on: {
    model_name: 'Delivery',
    column_type: 'date',
    label_key_path: 'delivery.reachOn',
  },
  check_on: {
    model_name: 'Delivery',
    column_type: 'date',
    label_key_path: 'delivery.checkOn',
  },
  standard_delivery_form: {
    model_name: 'Delivery',
    column_type: 'boolean',
    label_key_path: 'delivery.standardDeliveryForm',
  },
  broken_outer_package: {
    model_name: 'Delivery',
    column_type: 'boolean',
    label_key_path: 'delivery.brokenOuterPackage',
  },
  sampling_rate: {
    model_name: 'Delivery',
    column_type: 'float',
    label_key_path: 'delivery.samplingRate',
  },
  quality_comment: {
    model_name: 'Delivery',
    column_type: 'string',
    label_key_path: 'delivery.qualityComment',
  },
  delivery_quantity: {
    model_name: 'Delivery',
    column_type: 'integer',
    label_key_path: 'delivery.deliveryQuantity',
  },
  has_original: {
    model_name: 'Delivery',
    column_type: 'boolean',
    label_key_path: 'delivery.hasOriginal',
  },
  defective_quantity: {
    model_name: 'Delivery',
    column_type: 'integer',
    label_key_path: 'delivery.defectiveQuantity',
  },
  remark: {
    model_name: 'Delivery',
    column_type: 'string',
    label_key_path: 'delivery.remark',
  },
  check_images: {
    model_name: 'Delivery',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'delivery.checkImages',
  },
  check_images_with_audio: {
    model_name: 'Delivery',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'delivery.checkImagesWithAudio',
  },
  delivery_items: {
    model_name: 'Delivery',
    column_type: 'has_many',
    label_key_path: 'delivery.deliveryItems',
    extra: {
      association_name: 'delivery_items',
      model_name: 'DeliveryItem',
      foreign_key: 'delivery_id',
      display_column: 'id',
    },
  },
  delivery_item_ids: {
    model_name: 'Delivery',
    column_type: 'has_many',
    label_key_path: 'delivery.deliveryItems',
    extra: {
      association_name: 'delivery_items',
      model_name: 'DeliveryItem',
      foreign_key: 'delivery_id',
      display_column: 'id',
    },
  },
  delivery_items_attributes: {
    model_name: 'Delivery',
    column_type: 'string',
    label_key_path: 'delivery.deliveryItemsAttributes',
  },
  operation_logs: {
    model_name: 'Delivery',
    column_type: 'has_many',
    label_key_path: 'delivery.operationLogs',
    extra: {
      association_name: 'operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  operation_log_ids: {
    model_name: 'Delivery',
    column_type: 'has_many',
    label_key_path: 'delivery.operationLogs',
    extra: {
      association_name: 'operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  abilities: {
    model_name: 'Delivery',
    column_type: 'string',
    label_key_path: 'delivery.abilities',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
